import React from 'react'
import ErrorBoundary from '../errorboundry'
import InvoiceItem from './InvoiceItem'
import AccordionInvoice from '@commonComponents/accordion/AccordianInvoice'

const InvoiceItemList=({InvoiceItems, fieldPattern,procedureList}) =>{
 
  return (
    <ErrorBoundary>
    
       {
        InvoiceItems?.length && 
        <AccordionInvoice
        initialiState={{[InvoiceItems?.[0]?.['invoiceId']]:true}}
        keyName={"toggleInvoices"} 
        expandTitle={"OPEN_ALL_INVOICES"}
        collapseTitle={"CLOSE_ALL_INVOICES"}
        >
          {InvoiceItems.map((item,index)=>(
               <div 
               key={`invoice-${index}`}
               id={item?.['invoiceId']}
               >
               <InvoiceItem
                 key={item.invoiceId}
                 invoiceId={item.invoiceId}
                 invoiceItemIndex={index}
                 fieldPattern={fieldPattern}
                 procedureList={procedureList}
               />
             </div>
          ))}

        </AccordionInvoice>
       }

    </ErrorBoundary>
  )
}

export default React.memo(InvoiceItemList)
